import styles from '../ProductQuiz.module.scss';
import React, { useEffect } from 'react';
import { Button, Flex, Text } from '@mantine/core';
import { useProductQuiz } from '../ProductQuizContext';
import { QuestionTitle } from './QuestionTitle';
import { QuestionNextButton } from './QuestionNextButton';
import { quizQuestionPage } from '../../../lib/analytics/events';
import { Scrollable } from '../Helpers/Scrollable';
import { useTranslation } from 'react-i18next';

const IMPORTANT_ITEMS = [
  'Battery life',
  'Night light',
  'Durability',
  'Style',
  'Size',
  'Attachable to any harness or collar',
  'Waterproofness',
  'Lightweight',
];

export const QuestionImportance: React.FC = () => {
  const { t } = useTranslation();
  useEffect(() => {
    quizQuestionPage.quizWhatsImportantToYouPageEntered();
  }, []);

  const { quizAnswers, setQuizAnswers } = useProductQuiz();

  const addOrRemoveImportance = (name: string) => {
    const updatedImportance = new Set(quizAnswers.importance);
    if (updatedImportance.has(name)) {
      updatedImportance.delete(name);
    } else if (!updatedImportance.has(name) && updatedImportance.size < 3) {
      updatedImportance.add(name);
    }
    setQuizAnswers({ ...quizAnswers, importance: updatedImportance });
  };

  const items = IMPORTANT_ITEMS.map((name) => {
    const limitReached = quizAnswers.importance.size === 3;
    const selected = quizAnswers.importance.has(name);

    return (
      <Button
        key={name}
        unstyled
        data-active={quizAnswers.importance.has(name) || undefined}
        className={styles.quizButton}
        sx={{ borderRadius: 24, opacity: limitReached && !selected ? 0.5 : 1 }}
        onClick={() => {
          addOrRemoveImportance(name);
        }}
      >
        <Text
          size={16}
          weight={600}
          lh="120%"
          color="white"
          py={16}
          px={20}
          sx={(theme) => ({
            color: selected ? theme.colors['fi-yellow'] : 'white',
          })}
        >
          {name}
        </Text>
      </Button>
    );
  });

  return (
    <>
      <QuestionTitle subtitle={t('select_up_to_n', { count: 3 })}>{t('whats_most_important_to_you')}</QuestionTitle>
      <Scrollable>
        <Flex gap={12} wrap="wrap">
          {items}
        </Flex>
      </Scrollable>
      <QuestionNextButton
        showOnDesktop={true}
        isDisabled={quizAnswers.importance.size === 0}
        event={() => quizQuestionPage.quizWhatsImportantToYouNext(Array.from(quizAnswers.importance).sort().join(', '))}
      />
    </>
  );
};
